import { authorizationHelper } from '../helpers'
import { httpStatus, messages } from '../constants'

export function handle(error, dispatch, actionType) {

    const response = error.response

    if (!response) dispatch({ type: actionType, payload: { error: messages.GENERAL_ERROR } })
    else if (authorizationHelper.isUnauthorizedCall(dispatch, response)) return
    else if (response.status == httpStatus.BAD_REQUEST) {
        if (response.data.message) dispatch({ type: actionType, payload: { error: response.data.message } })
        else dispatch({ type: actionType, payload: { error: messages.GENERAL_ERROR } })
    }
    else dispatch({ type: actionType, payload: { error: messages.GENERAL_ERROR } })

}


// WEBPACK FOOTER //
// ./src/common/helpers/error.js